import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PlatformAdminDto } from '@parking/shared';

type PlatformAuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  admin: PlatformAdminDto | null;
  setSession: (payload: {
    accessToken: string;
    refreshToken: string;
    admin: PlatformAdminDto;
  }) => void;
  clear: () => void;
};

export const usePlatformAuthStore = create<PlatformAuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      admin: null,
      setSession: ({ accessToken, refreshToken, admin }) =>
        set({ accessToken, refreshToken, admin }),
      clear: () => set({ accessToken: null, refreshToken: null, admin: null }),
    }),
    { name: 'parking-platform-auth' },
  ),
);
